import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_kana_list = _resolveComponent("kana-list")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: _ctx.$t('attendance.title'), href: '/attendance/list', color: 'primary' },
          { title: _ctx.$t('attendance.checkIn') + ' & ' + _ctx.$t('attendance.checkOut') },
        ]
      }, null, 8, ["items"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('attendance.checkIn')) + " & " + _toDisplayString(_ctx.$t('attendance.checkOut')), 1)
    ]),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              indeterminate: "",
              color: "primary"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialog) = $event)),
      width: "620px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedChild ? _ctx.selectedChild.lastName + ' ' + _ctx.selectedChild.firstName : ""), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, { class: "py-8" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('attendance.siblingSettings')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedChildsSiblingAttendance, (siblingItem, i) => {
                      return (_openBlock(), _createBlock(_component_v_row, { key: i }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(siblingItem.child.lastName + ' ' + siblingItem.child.firstName), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                onClick: ($event: any) => (_ctx.attend(String(siblingItem.child.childId))),
                                disabled: 
                    _ctx.isUpdating || _ctx.isAttended(siblingItem.child.childId)
                  ,
                                small: "",
                                color: "primary",
                                variant: "flat",
                                class: "custom-disabled-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkIn')), 1),
                                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(_toDisplayString(_ctx.getAttendedTime(siblingItem.child.childId)), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"]),
                              _createVNode(_component_v_btn, {
                                onClick: ($event: any) => (_ctx.left(String(siblingItem.child.childId))),
                                disabled: 
                    _ctx.isUpdating ||
                    _ctx.isLeft(siblingItem.child.childId) ||
                    !_ctx.isAttended(siblingItem.child.childId)
                  ,
                                class: "ml-4 custom-disabled-btn",
                                small: "",
                                color: "secondary",
                                variant: "flat"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkOut')), 1),
                                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(_toDisplayString(_ctx.getLeftTime(siblingItem.child.childId)), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_v_row, { class: "pt-8" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              disabled: !_ctx.shouldAttendButtonEnabled,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.attend(String(_ctx.selectedChild?.childId)))),
                              color: "primary",
                              block: "",
                              style: {"height":"18vh","font-size":"1.8rem"},
                              class: "custom-disabled-btn"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkIn')), 1),
                                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(_toDisplayString(_ctx.selectedChild ? _ctx.getAttendedTime(_ctx.selectedChild.childId) : ""), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              disabled: 
                    !_ctx.shouldLeftButtonEnabled || _ctx.shouldAttendButtonEnabled
                  ,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.left(String(_ctx.selectedChild?.childId)))),
                              color: "secondary",
                              block: "",
                              class: "custom-disabled-btn",
                              style: {"height":"18vh","font-size":"1.8rem","color":"white !important"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkOut')), 1),
                                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(_toDisplayString(_ctx.selectedChild ? _ctx.getLeftTime(_ctx.selectedChild.childId) : ""), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, [
                  (_ctx.isUpdating)
                    ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                        key: 0,
                        indeterminate: "",
                        color: "primary",
                        class: "my-8"
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[2] || (_cache[2] = () => (_ctx.dialog = false)),
                  variant: "text",
                  color: "grey"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_container, {
      fluid: "",
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { style: {"height":"100vh"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "10",
              "align-self": "center",
              style: {"height":"100vh"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_kana_list, {
                  kanaArray: _ctx.kanaList,
                  onKanaClicked: _ctx.clickKana
                }, null, 8, ["kanaArray", "onKanaClicked"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  nav: "",
                  "bg-color": "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_subheader, { class: "text-white font-weight-bold" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('attendance.child')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider, {
                      color: "white",
                      thickness: "1",
                      class: "opacity-100"
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childrenList, (item) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: item.childId,
                        link: "",
                        onClick: ($event: any) => (_ctx.clickChild(item as NurseryChildResponse))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "text-white font-weight-bold" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.lastName + ' ' + item.firstName) + " ", 1),
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                  _createTextVNode("mdi-chevron-right", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}